import { useReactFlow, useNodesInitialized } from "@xyflow/react";
import { useEffect } from "react";
import dagre from "@dagrejs/dagre";
import { isEqual } from "lodash";

import {
  GRAPH_DIRECTION,
  NODE_SPACING_X,
  NODE_SPACING_Y,
} from "../OrgChart.constants";
export const useAutoLayout = (
  renderDiagram: number,
  setIsDiagramReady: (isReady: boolean) => void,
): void => {
  const { getNodes, getEdges, setNodes, setEdges } = useReactFlow();
  const nodesInitialized = useNodesInitialized();

  useEffect(() => {
    const nodes = getNodes();
    const edges = getEdges();

    if (!nodes.length) {
      return;
    }
    const dagreGraph = new dagre.graphlib.Graph({}).setDefaultEdgeLabel(() => ({
      directed: true,
    }));

    dagreGraph.setGraph({
      rankdir: GRAPH_DIRECTION,
      ranksep: NODE_SPACING_X,
      nodesep: NODE_SPACING_Y,
    });

    nodes.forEach((node) => {
      const titleLength = (node.data as { name?: string }).name?.length || 0;
      const width = Math.max(150, titleLength * 10);

      dagreGraph.setNode(node.id, { width, height: 50 });
    });

    edges.forEach((edge) => {
      dagreGraph.setEdge(edge.source, edge.target);
    });

    dagre.layout(dagreGraph);

    const nodePositions = new Set();

    const newNodes = nodes.map((node) => {
      const nodeWithPosition = dagreGraph.node(node.id);
      let { x, y } = nodeWithPosition;

      // Ensure nodes do not overlap horizontally or vertically
      while (nodePositions.has(`${x},${y}`)) {
        x += NODE_SPACING_X;
        y += NODE_SPACING_Y;
      }
      nodePositions.add(`${x},${y}`);

      return {
        ...node,
        position: {
          x: x - nodeWithPosition.width / 2,
          y,
        },
      };
    });

    // Only set nodes and edges if they have changed
    if (!isEqual(newNodes, nodes)) {
      setNodes(newNodes);
    }
    if (!isEqual(edges, getEdges())) {
      setEdges(edges);
    }

    setTimeout(() => {
      setIsDiagramReady(true);
    }, 100);
  }, [nodesInitialized, renderDiagram]);
};
